(function (angular) {
    'use strict';

    angular.module('profiles')
        /**
         *
         */
        .controller('profileTemplateCtrl', ['$scope', '$stateParams', 'template', 'profileTemplateService', '$uibModal', 'profileHelper', 'profilesService', 'utilService', 'sweetAlertService', 'growlService', function ($scope, $stateParams, template, profileTemplateService, $uibModal, profileHelper, profilesService, utilService, sweetAlertService, growlService) {
            $scope.edit = {};
            $scope.hide = [];
            $scope.profileTemplate = template.schema;
            $scope.profileTemplateCache = angular.copy(template).schema;
            $scope.allowOtherProperties = template._allowOtherProperties;
            $scope.otherPropertiesChange = function(){
                profileTemplateService.allowOtherProperties($stateParams.pickedApiSpaceId, $scope.allowOtherProperties).then(function(){
                    profilesService.getProfileSchema($stateParams.pickedApiSpaceId).then(function(result){
                        profileHelper.setSchema(result);
                    }).catch(function(error){
                    });
                }).catch(function(error){
                    $scope.allowOtherProperties = !$scope.allowOtherProperties;
                });
            };
            
            $scope.types = utilService.getFieldTypes();
            $scope.translateType = utilService.translateFieldType;
            $scope.deleteProperty = function(propertyGroup, propertyName){
                delete propertyGroup.properties[propertyName];
            };

            $scope.deleteGroup = function(propertyGroupName){
                sweetAlertService.confirmationAlert(
                    "Are you sure?",
                    "You will delete this group and all associated properties?",
                    "Yes, delete it!",
                    "No",
                    function(isConfirm){
                        if (isConfirm) {     
                            delete $scope.profileTemplate[propertyGroupName];
                            $scope.save(propertyGroupName);
                        }

                    }
                );
            };

            $scope.addProperty = function(propertyGroup){
                var modalInstance = $uibModal.open({
                    animation: true,
                    templateUrl: 'components/toolkit/profiles/templates/addMasterPropertyModal.html',
                    controller: 'addMasterModal',
                    resolve:{
                        mode: function(){
                            return 'property';
                        },
                        types: function(){
                            return $scope.types;
                        },
                        existingProperties: function(){
                            return propertyGroup.properties;
                        }
                    }
                });

                modalInstance.result.then(function (property) {
                    propertyGroup.properties[property.name] = {
                        label: property.label,
                        type: property.type
                    };

                });
            };


            $scope.addGroup = function(){
                var modalInstance = $uibModal.open({
                    animation: true,
                    templateUrl: 'components/toolkit/profiles/templates/addMasterPropertyModal.html',
                    controller: 'addMasterModal',
                    resolve:{
                        mode: function(){
                            return 'group';
                        },
                        types: function(){
                            return $scope.types;
                        },
                        existingProperties: function(){
                            return $scope.profileTemplate;
                        }
                    }
                });

                modalInstance.result.then(function (group) {
                    $scope.profileTemplate[group.name] = {
                        label: group.label,
                        path: group.name,
                        properties: {}
                    };

                    $scope.edit[group.name] = true;

                });
            };

            $scope.save = function(groupName){
                profileTemplateService.updateProfileTemplate($stateParams.pickedApiSpaceId, $scope.profileTemplate).then(function(){
                    $scope.profileTemplateCache[groupName] = angular.copy($scope.profileTemplate[groupName]);
                    $scope.edit[groupName] = false;
                    profilesService.getProfileSchema($stateParams.pickedApiSpaceId).then(function(result){
                        profileHelper.setSchema(result);
                        growlService.success("Profile Template successfully updated");
                    }).catch(function(error){
                        growlService.danger("Couldn't get new profile schema due to " + error.statusText);
                    });
                }).catch(function(error){
                    growlService.danger("Profile Template wasn't updated due to: " + error.statusText);
                });
            };
            $scope.cancel = function(groupName){
                if(!$scope.profileTemplateCache[groupName]){
                    delete $scope.profileTemplate[groupName];
                } else {
                    $scope.profileTemplate[groupName] = angular.copy($scope.profileTemplateCache[groupName]);
                }
                $scope.edit[groupName] = false;
            };
            $scope.startEdit = function(groupName){
                $scope.edit[groupName] = true;
            };
        }]).controller('addMasterModal', ['$scope', 'mode', '$uibModalInstance', 'types', 'existingProperties', function ($scope, mode, $uibModalInstance, types, existingProperties){
            
            var allowedChars = /^[a-zæøåA-Z0-9-_]+$/;
            var allowedCharsMatch = /[^a-zæøåA-Z0-9-_]/g;

            $scope.existingProperties = angular.copy(existingProperties);
            $scope.types = types;
            $scope.mode = mode;
            $scope.data = {
                autoGenerateName: true,
                type: ''
            };

            $scope.isNameCorrect = function(){
                return $scope.data.autoGenerateName || (!$scope.data.autoGenerateName && allowedChars.test($scope.data.name));
            }
            $scope.existingNameCheck = function(){
                return $scope.existingProperties[$scope.data.name];
            };
            $scope.existingLabelCheck = function(){
                for(var name in $scope.existingProperties){
                    if($scope.existingProperties[name].label == $scope.data.label){
                        return true;
                    }
                }
                return false;
            };
            $scope.existingCheck = function(){
                return $scope.existingNameCheck() || $scope.existingLabelCheck();
            };
            $scope.readyCheck = function(){
                return $scope.mode == "property" ? $scope.data.type : true && $scope.data.name && $scope.data.label;
            };
            $scope.generateName = function(){
                if($scope.data.label){
                    $scope.data.name = $scope.data.label.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function(match, index) {
                        if (+match === 0) return ""; // or if (/\s+/.test(match)) for white spaces
                        return index === 0 ? match.toLowerCase() : match.toUpperCase();
                      }).replace(allowedCharsMatch, "");
                }
                else{
                    $scope.data.name = '';
                }
            };
            $scope.save = function () {
                $uibModalInstance.close($scope.data);
            };
            $scope.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        }]);

})(window.angular);